/*
 * Copyright (c) 2020 CalAmp Corp.  All Rights Reserved
 */
import React from 'react';
import {OMIT_CLICK_AWAY_LISTENER} from '../maps/constants';
import {IconProps} from '../types/types';
import ThemeIconProvider from './ThemeIconProvider';
import useIconDLS from './useIconDLS';

/*
 * Defines the Design Language System (DLS) Material MoreVert Icon component.
 */
export const MaterialMoreVertIcon = (props: IconProps) => {
  const {iconSize, iconColor} = useIconDLS(props);
  return (
    <ThemeIconProvider name='MaterialMoreVertIcon' size={iconSize} color={iconColor as any} legacyIcon={(
      <svg width={iconSize} height={iconSize} className={OMIT_CLICK_AWAY_LISTENER} viewBox='0 0 24 24' fill='none'>
        <path d='M12 8c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2zm0 2c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm-2 8c0-1.1.9-2 2-2s2 .9 2 2-.9 2-2 2-2-.9-2-2z'
          fillRule='evenodd'
          clipRule='evenodd'
          fill={iconColor} />
      </svg>
    )} />
  );
};
